import {
  EquipmentType,
  Order,
  Task,
  Tractor,
  Trailer,
  TripDetail,
} from '../../pages/trip/trip.types'
import { Driver, Owner } from '../drivers/drivers.type'
import { CreateTripPayload, OrderEvent, TripResponse } from './trips.types'

export const CreateTripsFixture: CreateTripPayload = {
  userId: window.sessionStorage.getItem('userId') ?? '',
  userTripId: '',
  firstDriverName: '',
  firstDriverId: '',
  secondDriverName: '',
  secondDriverId: '',
  tripType: 'DRIVER_TRIP',
  tripTasks: [],
}

const OwnerFixture: Owner = {
  id: '',
  companyName: '',
  companyAddress: '',
  email: '',
  taxNumber: '',
  taxPercentage: '',
  orderStartNumber: '',
  tripPrefix: '',
  tripStartNumber: '',
  invoicePrefix: '',
  invoiceStartNumber: '',
  orderPrefix: '',
  deletedAt: '',
  createdAt: '',
  modifiedAt: '',
  outMail: '',
}

export const DriverFixture: Driver = {
  id: '',
  firstName: '',
  lastName: '',
  phone: '',
  address: '',
  licenseNumber: '',
  dateOfIssue: '',
  expiryDate: '',
  driverReferenceNumber: '',
  sex: '',
  licenseClass: '',
  restrictions: '',
  dateOfBirth: '',
  height: 0,
  typeOfLicense: '',
  province: '',
  owner: OwnerFixture,
  tractorId: '',
  trailerId: '',
  verified: '',
  createdAt: '',
  modifiedAt: '',
  driverAppStatus: '',
  citizenshipCountry: '',
  fastCardNumber: '',
}

export const OrderPickupFixture: OrderEvent = {
  address: '',
  endTime: '',
  eventType: 'PICKUP',
  hazmat: '',
  loadCount: 0,
  loadType: 'LTL',
  name: '',
  notes: '',
  orderEventId: 0,
  pickupNumber: '',
  startTime: '',
  temperatureUnit: '',
  temperatureValue: 0,
  weightUnit: '',
  weightValue: 0,
}

export const OrderDeliveryFixture: OrderEvent = {
  address: '',
  endTime: '',
  eventType: 'PICKUP',
  hazmat: '',
  loadCount: 0,
  loadType: 'LTL',
  name: '',
  notes: '',
  orderEventId: 0,
  pickupNumber: '',
  startTime: '',
  temperatureUnit: '',
  temperatureValue: 0,
  weightUnit: '',
  weightValue: 0,
}

const makeNewItem = (
  id: string,
  task: Task,
  equipmentType: EquipmentType,
  orderItemId?: string
): TripDetail => ({
  task,
  equipment: { equipmentId: id, equipmentType, orderItemId },
  date: '2016-05-25T09:08:34.123+06:00',
  estimateDate: '2016-05-25T09:08:34.123+06:00',
  company: {
    companyId: '12345',
    companyName: 'DEF Logistics',
    address: {
      street: '789 Oak Avenue',
      city: 'Sarnia',
      state: 'ON',
    },
  },
})

export const tractorsFixture: Tractor[] = [
  { tractorId: 'D12345' },
  { tractorId: 'D23456' },
]

export const trailersFixture: Trailer[] = [
  { trailerId: 'ABC12345' },
  { trailerId: 'ABC23456' },
]

export const ordersFixture: Order[] = [
  {
    orderId: 'ORD1234',
    orders: [
      makeNewItem('ORD1234', 'pickup', 'Order', 'ORD12341'),
      makeNewItem('ORD1234', 'pickup', 'Order', 'ORD12342'),
      makeNewItem('ORD1234', 'delivery', 'Order', 'ORD12343'),
    ],
  },
  {
    orderId: 'ORD2345',
    orders: [
      makeNewItem('ORD2345', 'pickup', 'Order', 'ORD23451'),
      makeNewItem('ORD2345', 'pickup', 'Order', 'ORD23452'),
      makeNewItem('ORD2345', 'delivery', 'Order', 'ORD23453'),
    ],
  },
]

export const addTractorFixture = (tractorId: string): TripDetail[] => [
  makeNewItem(tractorId, 'hook', 'Tractor'),
  makeNewItem(tractorId, 'drop', 'Tractor'),
]

export const addTrailerHookFixture = (trailerId: string): TripDetail =>
  makeNewItem(trailerId, 'hook', 'Trailer')

export const addTrailerDropFixture = (trailerId: string): TripDetail =>
  makeNewItem(trailerId, 'drop', 'Trailer')

export const TripFixture: TripResponse = {
  tripId: 0,
  firstDriverId: '',
  firstDriverName: '',
  secondDriverId: '',
  secondDriverName: '',
  tripType: 'DRIVER_TRIP',
  status: 'ACTIVE',
  tripTasks: [],
  userId: '',
  userTripId: '',
}
